/* ═══════════════════════════════════════════
   SEIKO PRESTIGE — CART ENGINE v5
   Vanilla ES6+ | Zero deps
   ═══════════════════════════════════════════ */
(() => {
  'use strict';

  const PALIERS = [
    { min: 0, max: 0,        pct: 0,   state: 'empty',
      msg: 'Ajoutez 2 montres pour recevoir la 3ème en cadeau.' },
    { min: 1, max: 1,        pct: 33,  state: 'one',
      msg: '✧ Ajoutez 1 montre pour débloquer votre 3ème GRATUITE.' },
    { min: 2, max: 2,        pct: 66,  state: 'two',
      msg: '✧ Presque ! Plus qu\'une montre pour obtenir la 3ème OFFERTE.' },
    { min: 3, max: Infinity, pct: 100, state: 'unlocked',
      msg: '✅ Félicitations ! Votre 3ème montre est à 0€.' },
  ];

  const drawer  = document.getElementById('gc-drawer');
  const overlay = document.getElementById('gc-overlay');
  if (!drawer || !overlay) return;

  let prevItemCount   = parseInt(document.getElementById('gc-count')?.textContent || '0', 10);
  let pendingDiscount = '';

  // Cache des icônes de paiement rendues par Liquid (payment_type_svg_tag)
  const PAY_ICONS_HTML = document.getElementById('gc-pay-icons-cache')?.innerHTML || '';

  // ── DELIVERY DATE ─────────────────────────
  function getDeliveryDate() {
    const d = new Date();
    d.setDate(d.getDate() + 7);
    const str = d.toLocaleDateString('fr-FR', {
      day: 'numeric', month: 'long', year: 'numeric',
    });
    // "12 novembre 2026" → "12 Novembre 2026"
    return str.replace(/ ([a-zàâäéèêëîïôùûüÿœæ])/u, (_, c) => ' ' + c.toUpperCase());
  }

  function injectDeliveryDate() {
    const date = getDeliveryDate();
    document.querySelectorAll('.gc-date-value').forEach(el => { el.textContent = date; });
  }

  // ── HELPERS ──────────────────────────────
  function shopifyImg(src, size = '160x160') {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|gif|webp|svg))(\?.*)?$/i, `_${size}_crop_center$1$3`);
  }
  function money(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  // ── OPEN / CLOSE ─────────────────────────
  function openDrawer() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawer);
  document.getElementById('gc-close')?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // ── INTERCEPT CART ICON (capture avant Dawn) ──
  document.addEventListener('click', e => {
    const t = e.target.closest(
      'a[href="/cart"],[data-cart-toggle],#cart-icon-bubble,' +
      '.cart-link,.header__icon--cart,[aria-controls="CartDrawer"],.icon-cart'
    );
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDrawer();
  }, true);
  document.addEventListener('CartDrawer:open', e => {
    e.stopImmediatePropagation(); openDrawer();
  }, true);

  // ── GAMIFICATION ─────────────────────────
  function updateGamification(count) {
    const palier = PALIERS.find(p => count >= p.min && count <= p.max);
    if (!palier) return;

    const fill     = document.getElementById('gc-progress-fill');
    const msg      = document.getElementById('gc-reward-msg');
    const countEl  = document.getElementById('gc-count');
    const countLbl = document.querySelector('.gc-count-label');

    if (fill) { fill.style.width = palier.pct + '%'; fill.dataset.state = palier.state; }
    if (msg)  { msg.textContent = palier.msg; msg.dataset.state = palier.state; }
    if (countEl) {
      countEl.textContent = count;
      countEl.classList.add('bump');
      countEl.addEventListener('animationend', () => countEl.classList.remove('bump'), { once: true });
    }
    if (countLbl) countLbl.textContent = `${count} article${count !== 1 ? 's' : ''}`;

    // Sync header natif Dawn
    document.querySelectorAll('.cart-count-bubble span,[data-cart-count]').forEach(el => {
      el.textContent = count;
    });
    // Icone panier TOUJOURS visible (ne jamais la cacher, meme panier vide)
    document.getElementById('cart-icon-bubble')?.classList.remove('hidden');

    if (palier.state === 'unlocked' && prevItemCount < 3) {
      drawer.classList.add('is-celebrating');
      drawer.addEventListener('animationend', () => drawer.classList.remove('is-celebrating'), { once: true });
    }
    prevItemCount = count;
  }

  // ── API ──────────────────────────────────
  async function fetchCart() {
    const r = await fetch('/cart.js');
    if (!r.ok) throw new Error('fetchCart ' + r.status);
    return r.json();
  }
  async function cartChange(key, qty) {
    const body = document.getElementById('gc-body');
    body?.classList.add('is-loading');
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!r.ok) throw new Error('cartChange ' + r.status);
      renderCart(await r.json());
    } catch (e) { console.error('[GC]', e); }
    finally { body?.classList.remove('is-loading'); }
  }

  // ── UPSELLS ──────────────────────────────
  async function loadUpsells(cart) {
    const wrap = document.getElementById('gc-upsells');
    const grid = document.getElementById('gc-upsells-grid');
    if (!wrap || !grid || !cart.item_count) return;

    const cartIds = new Set(cart.items.map(i => i.product_id));
    const seedId  = cart.items[0]?.product_id;
    if (!seedId) return;

    try {
      const r = await fetch(`/recommendations/products.json?product_id=${seedId}&limit=6&intent=related`);
      if (!r.ok) return;
      const { products } = await r.json();
      const picks = products.filter(p => !cartIds.has(p.id) && p.available).slice(0, 2);
      if (!picks.length) { wrap.style.display = 'none'; return; }

      grid.innerHTML = picks.map(p => {
        const v   = p.variants[0];
        const img = p.featured_image ? shopifyImg(p.featured_image, '120x120') : '';
        return `
          <div class="gc-upsell-item">
            ${img ? `<img src="${img}" alt="${p.title.replace(/"/g,'&quot;')}" class="gc-upsell-img" loading="lazy" width="52" height="52">` : ''}
            <div class="gc-upsell-info">
              <div class="gc-upsell-title">${p.title}</div>
              <div class="gc-upsell-price">${money(v.price)}</div>
            </div>
            <button class="gc-upsell-add" data-variant="${v.id}" aria-label="Ajouter ${p.title}">+</button>
          </div>`;
      }).join('');

      wrap.style.display = '';
      grid.querySelectorAll('.gc-upsell-add').forEach(btn => {
        btn.addEventListener('click', async () => {
          btn.disabled = true; btn.textContent = '…';
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: Number(btn.dataset.variant), quantity: 1 }),
            });
            if (!res.ok) throw new Error();
            renderCart(await fetchCart());
          } catch { btn.disabled = false; btn.textContent = '+'; }
        });
      });
    } catch (e) { console.error('[GC upsells]', e); }
  }

  // ── PROMO ────────────────────────────────
  function initPromo() {
    const apply    = document.getElementById('gc-promo-apply');
    const input    = document.getElementById('gc-promo-input');
    const feedback = document.getElementById('gc-promo-feedback');
    if (!apply || !input) return;

    function applyCode() {
      const code = input.value.trim().toUpperCase();
      if (!code) { setFb('Saisissez un code promo.', 'err'); return; }
      pendingDiscount = code;
      const btn = document.getElementById('gc-checkout-btn');
      if (btn) btn.href = `/checkout?discount=${encodeURIComponent(code)}`;
      setFb('✓ Code appliqué — actif au checkout.', 'ok');
    }
    function setFb(msg, type) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.className = 'gc-promo-feedback ' + type;
    }
    apply.addEventListener('click', applyCode);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') applyCode(); });
  }

  // ── BUILD HTML ────────────────────────────
  function buildPricing(item) {
    const compareAt = item.compare_at_price;
    const hasCompare = compareAt && compareAt > item.final_price;
    const hasDiscount = item.original_price !== item.final_price;
    const strikePrice = hasCompare ? compareAt : (hasDiscount ? item.original_price : 0);

    if (strikePrice) {
      const label = item.final_price === 0 ? 'Offert' : money(item.final_price);
      const cls = item.final_price === 0 ? ' gc-price-free' : '';
      return `<span class="gc-price-original">${money(strikePrice)}</span>
              <span class="gc-price-final${cls}">${label}</span>`;
    }
    return `<span class="gc-price-final">${money(item.final_price)}</span>`;
  }

  function buildItem(item) {
    const variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? `<p class="gc-item-variant">${item.variant_title}</p>` : '';
    return `
      <li class="gc-item" data-key="${item.key}" data-product-id="${item.product_id}">
        <a href="${item.url}" class="gc-item-img-wrap" tabindex="-1">
          <img src="${shopifyImg(item.image)}" alt="${item.title.replace(/"/g,'&quot;')}"
               class="gc-item-img" loading="lazy" width="70" height="70">
        </a>
        <div class="gc-item-info">
          <div class="gc-item-top">
            <a href="${item.url}" class="gc-item-title">${item.product_title}</a>
            <button class="gc-remove" data-key="${item.key}" aria-label="Retirer">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          ${variant}
          <div class="gc-item-bottom">
            <div class="gc-qty-wrap">
              <button class="gc-qty-btn gc-qty-minus" data-key="${item.key}" aria-label="Diminuer">−</button>
              <span class="gc-qty-value">${item.quantity}</span>
              <button class="gc-qty-btn gc-qty-plus" data-key="${item.key}" aria-label="Augmenter">+</button>
            </div>
            <div class="gc-item-pricing">${buildPricing(item)}</div>
          </div>
        </div>
      </li>`;
  }

  function buildSummary(cart) {
    const compareSavings = cart.items.reduce((acc, item) => {
      if (item.compare_at_price && item.compare_at_price > item.original_price) {
        return acc + (item.compare_at_price - item.original_price) * item.quantity;
      }
      return acc;
    }, 0);
    const totalSavings = cart.total_discount + compareSavings;

    const savingsRow = totalSavings > 0
      ? `<div class="gc-summary-row gc-summary-row--savings">
           <span class="gc-summary-label gc-savings-label">Vous économisez</span>
           <span class="gc-summary-savings-val">−${money(totalSavings)}</span>
         </div>` : '';

    return `
      <div class="gc-summary-row">
        <span class="gc-summary-label">Sous-total</span>
        <span class="gc-summary-val">${money(cart.original_total_price)}</span>
      </div>
      <div class="gc-summary-row">
        <span class="gc-summary-label">Livraison</span>
        <span class="gc-summary-free">Offerte</span>
      </div>
      ${savingsRow}
      <div class="gc-summary-divider"></div>
      <div class="gc-summary-row gc-summary-row--total">
        <span>Total</span>
        <span id="gc-total">${money(cart.total_price)}</span>
      </div>`;
  }

  // ── RENDER COMPLET ────────────────────────
  function renderCart(cart) {
    const body   = document.getElementById('gc-body');
    const footer = document.getElementById('gc-footer');
    updateGamification(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="gc-empty">
          <div class="gc-empty-icon-wrap">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8" stroke="#D4AF37" stroke-width="1.2"/>
              <path d="M12 8.5v3.5l2.5 2.5" stroke="#D4AF37" stroke-width="1.2" stroke-linecap="round"/>
              <rect x="10" y="1.5" width="4" height="2.5" rx=".8" stroke="#D4AF37" stroke-width="1.2"/>
              <rect x="10" y="20" width="4" height="2.5" rx=".8" stroke="#D4AF37" stroke-width="1.2"/>
            </svg>
          </div>
          <p class="gc-empty-title">Votre sélection est vide.</p>
          <button class="gc-btn-continue">Explorer la collection</button>
        </div>`;
      footer?.classList.add('gc-footer--hidden');
      body.querySelector('.gc-btn-continue')?.addEventListener('click', closeDrawer);
      return;
    }

    body.innerHTML = `
      <ul class="gc-items-list">${cart.items.map(buildItem).join('')}</ul>
      <div id="gc-upsells" class="gc-upsells" style="display:none">
        <p class="gc-upsells-label">Vous aimerez peut-être</p>
        <div id="gc-upsells-grid" class="gc-upsells-grid"></div>
      </div>`;

    if (footer) {
      footer.classList.remove('gc-footer--hidden');
      const href = pendingDiscount
        ? `/checkout?discount=${encodeURIComponent(pendingDiscount)}`
        : '/checkout';

      footer.innerHTML = `
        <div class="gc-promo-wrap" id="gc-promo-wrap">
          <div class="gc-promo-row">
            <input type="text" id="gc-promo-input" class="gc-promo-input" placeholder="Entrez votre code" autocomplete="off" autocapitalize="characters">
            <button id="gc-promo-apply" class="gc-promo-apply">Appliquer</button>
          </div>
          <p class="gc-promo-feedback" id="gc-promo-feedback" aria-live="polite"></p>
        </div>
        <div class="gc-summary" id="gc-summary">${buildSummary(cart)}</div>
        <p class="gc-delivery-date" id="gc-delivery-date">
          Livraison estimée le <span class="gc-date-value"></span>
        </p>
        <a href="${href}" id="gc-checkout-btn" class="gc-checkout-btn">Finaliser la commande</a>
        <div class="gc-pay-icons-wrap" aria-label="Moyens de paiement">${PAY_ICONS_HTML}</div>`;

      initPromo();
    }

    injectDeliveryDate();
    bindBodyEvents();
    loadUpsells(cart);
  }

  // ── BODY EVENTS ───────────────────────────
  function bindBodyEvents() {
    const body = document.getElementById('gc-body');
    if (!body || body._gcBound) return;
    body._gcBound = true;
    body.addEventListener('click', e => {
      const minus  = e.target.closest('.gc-qty-minus');
      const plus   = e.target.closest('.gc-qty-plus');
      const remove = e.target.closest('.gc-remove');
      if (minus) {
        const qty = parseInt(minus.closest('.gc-item')?.querySelector('.gc-qty-value')?.textContent || '1', 10);
        cartChange(minus.dataset.key, Math.max(0, qty - 1));
      } else if (plus) {
        const qty = parseInt(plus.closest('.gc-item')?.querySelector('.gc-qty-value')?.textContent || '1', 10);
        cartChange(plus.dataset.key, qty + 1);
      } else if (remove) {
        cartChange(remove.dataset.key, 0);
      }
    });
  }

  // ── INTERCEPT ADD-TO-CART ─────────────────
  function interceptForm(form) {
    if (form.dataset.gcBound) return;
    form.dataset.gcBound = '1';
    form.addEventListener('submit', async e => {
      e.preventDefault(); e.stopImmediatePropagation();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn?.innerHTML;
      if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.description || 'Erreur panier');
        }
        renderCart(await fetchCart());
        openDrawer();
      } catch (err) {
        console.error('[GC]', err); showToast(err.message);
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      }
    }, true);
  }

  // ── TOAST ────────────────────────────────
  function showToast(msg) {
    const t = document.createElement('div');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
      background: '#111', color: '#fff', padding: '11px 18px', borderRadius: '8px',
      fontSize: '12px', zIndex: '99999', border: '1px solid rgba(212,175,55,.2)',
      boxShadow: '0 4px 24px rgba(0,0,0,.15)', pointerEvents: 'none',
    });
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3200);
  }

  // ── OBSERVER (Quick Add) ──────────────────
  new MutationObserver(() => {
    document.querySelectorAll('form[action="/cart/add"]').forEach(interceptForm);
  }).observe(document.body, { childList: true, subtree: true });

  // ── INIT ─────────────────────────────────
  function init() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(interceptForm);
    bindBodyEvents();
    initPromo();
    injectDeliveryDate();
    fetchCart().then(cart => {
      prevItemCount = cart.item_count;
      updateGamification(cart.item_count);
    }).catch(console.error);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
